import { newProjectId } from '~/constant'

export const projectsRoot = '/projects'
export const mobileImport = '/mobile-import'
export const adminPanelRoot = '/admin_panel'

export const AppRoutes = {
  Projects: projectsRoot,
  NewProject: `${projectsRoot}/${newProjectId}`,
  MobileImport: mobileImport,
  AdminPanel: adminPanelRoot,
  AdminStats: `${adminPanelRoot}/stats`,
  AdminRecentUsers: `${adminPanelRoot}/recent_users`,
  AdminUser: `${adminPanelRoot}/recent_users/:id`,
  AdminRecentProjects: `${adminPanelRoot}/recent_projects`,
  AdminRecentMediaFiles: `${adminPanelRoot}/recent_media_files`,
  AdminMediaFileErrors: `${adminPanelRoot}/mediafile_errors`,
  AdminRenderErrors: `${adminPanelRoot}/render_errors`,
}
